import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import NewAppFormFields from './NewAppFormFields';

const NewAppForm = ({
  initialValues,
  onSubmit,
  showFileInput = true,
  handleCloseModal,
  FieldsComponent = NewAppFormFields,
}) => {
  const [appInfoForm, setAppInfoForm] = useState(initialValues);

  const handleChange = (e) => {
    const { name, type, value, files } = e.target;
    let finalValue;
    if (type === 'file') {
      finalValue = files[0];
    } else {
      finalValue = value;
    }
    setAppInfoForm((prev) => ({ ...prev, [name]: finalValue }));
  };

  const handleSubmit = async () => {
    await onSubmit(appInfoForm);
  };

  return (
    <>
      <FieldsComponent
        form={appInfoForm}
        handleChange={handleChange}
        showFileInput={showFileInput}
        width="95%"
      />
      <Box sx={{ padding: 2, width: '50%', mx: 'auto', mt: 1, display: 'flex', justifyContent: 'center', gap: 4 }}>
        <Button
          variant="outlined"
          onClick={handleCloseModal}
          sx={{ borderRadius: '12px', textTransform: 'none', fontSize: '16px', width: '120px', color: '#16a4b0', borderColor: '#16a4b0', '&:hover': { backgroundColor: '#f0f0f0', borderColor: '#16a4b0' } }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{ borderRadius: '12px', backgroundColor: '#16a4b0', color: 'white', textTransform: 'none', fontSize: '16px', width: '120px', '&:hover': { backgroundColor: '#00707c' } }}
        >
          Import
        </Button>
      </Box>
    </>
  );
};

export default NewAppForm;
